import { Injectable, inject } from '@angular/core';

import { EventOptionGroup, Tv2MarketParameters } from '@frontend/sports/betting-offer/feature/model';
import { NOT_APPLICABLE, TrackData, TrackingService, trackingConstants } from '@frontend/sports/tracking/feature';

@Injectable({ providedIn: 'root' })
export class MarketHelpTrackingService {
    trackingService = inject(TrackingService);

    trackToggle(optionGroup: EventOptionGroup, leagueId: number, sportId: number): void {
        const trackData = {
            [trackingConstants.COMPONENT_ACTION_EVENT]: `click`,
            [trackingConstants.COMPONENT_POSITION_EVENT]: this.getPositionEvent(optionGroup),
            [trackingConstants.COMPONENT_LOCATION_EVENT]: optionGroup.name,
            [trackingConstants.COMPONENT_EVENT_DETAILS]: 'info icon',
            [trackingConstants.COMPONENT_SPORT_ID]: sportId,
            [trackingConstants.COMPONENT_LEAGUE_ID]: leagueId,
            [trackingConstants.COMPONENT_MARKET_ID]: optionGroup.id,
        };

        this.track(trackData);
    }

    trackLink(optionGroup: EventOptionGroup, link: string): void {
        const trackData = {
            [trackingConstants.COMPONENT_ACTION_EVENT]: 'More Info Link - Click',
            [trackingConstants.COMPONENT_POSITION_EVENT]: this.getPositionEvent(optionGroup),
            [trackingConstants.COMPONENT_LOCATION_EVENT]: optionGroup.name,
            [trackingConstants.COMPONENT_URL_CLICKED]: link,
        };

        this.track(trackData);
    }

    private track(additionalTrackData: Partial<TrackData>): void {
        const fullTrackData = { ...this.getBaseTrackData(), ...additionalTrackData };

        this.trackingService.track(trackingConstants.EVENT_TRACKING, fullTrackData);
    }

    private getBaseTrackData(): Partial<TrackData> {
        return {
            [trackingConstants.COMPONENT_CATEGORY_EVENT]: 'market help',
            [trackingConstants.COMPONENT_LABEL_EVENT]: 'market help',
            [trackingConstants.COMPONENT_POSITION_EVENT]: NOT_APPLICABLE,
            [trackingConstants.COMPONENT_URL_CLICKED]: NOT_APPLICABLE,
            [trackingConstants.COMPONENT_EVENT_DETAILS]: NOT_APPLICABLE,
        };
    }

    private getPositionEvent(optionGroup: EventOptionGroup): string {
        return optionGroup.parameters?.find((p) => p.key === Tv2MarketParameters.MarketType)?.value ?? this.parseId(optionGroup.id);
    }

    private parseId(id: string): string {
        const match = id.match('^((.*)-)?(\\d+)$');

        return match && match[3] ? match[3] : id;
    }
}
